
	import { defineComponent } from 'vue'

	import ChannelBox from '@/components/ChannelBox.vue'
	import Flickity from '@/components/Flickity.vue'
	import { ChannelPack, useChannelPackInfo } from '@/composables/useChannelPackInfo'

	export default defineComponent({
		components: {
			ChannelBox,
			Flickity,
		},

		setup() {
			return {
				flex: useChannelPackInfo(ChannelPack.Flex),
				at120: useChannelPackInfo(ChannelPack.AT120),
				at120plus: useChannelPackInfo(ChannelPack.AT120Plus),
				at200: useChannelPackInfo(ChannelPack.AT200),

				options: {
					groupCells: true,
					pageDots: false,
					watchCSS: true,
				},
			}
		},
	})
